module.exports = __webpack_public_path__ + "static/media/users2.9e71cbc7.svg";